export enum EDataLoadingMode {
  AUTO,
  MANUAL,
}
